import { useState, useEffect, useCallback } from 'react';

/**
 * Stato di raggiungibilità dell'API (non solo navigator.onLine).
 */
export function useOnlineStatus(pollMs = 45000) {
  const [apiReachable, setApiReachable] = useState(true);
  const [checking, setChecking] = useState(false);

  const ping = useCallback(async () => {
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      setApiReachable(false);
      return;
    }
    setChecking(true);
    try {
      const r = await fetch('/api/settings/public-status', {
        method: 'GET',
        cache: 'no-store',
        credentials: 'include',
      });
      setApiReachable(r.ok);
    } catch {
      setApiReachable(false);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => {
    void ping();
    const onOnline = () => void ping();
    const onOffline = () => setApiReachable(false);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    const id = window.setInterval(() => void ping(), pollMs);
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
      window.clearInterval(id);
    };
  }, [ping, pollMs]);

  return { apiReachable, checking, recheck: ping };
}
